type ProgressRingProps = {
  /** 0..1 completion. */
  ratio: number;
  /** Outer diameter in px. */
  size?: number;
  strokeWidth?: number;
  /** Dim (accent/35) instead of the full accent when inactive. */
  active?: boolean;
  className?: string;
};

/** Circular completion indicator — flat accent stroke, animated dash offset. */
export function ProgressRing({
  ratio,
  size = 76,
  strokeWidth = 4,
  active = true,
  className,
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.min(Math.max(ratio, 0), 1);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className ?? "absolute inset-0 -rotate-90"}
      aria-hidden
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="rgba(255,255,255,0.09)"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={active ? "var(--ty-accent)" : "color-mix(in oklab, var(--ty-accent) 35%, transparent)"}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference * (1 - clamped)}
        className="transition-[stroke-dashoffset] duration-700 ease-out"
      />
    </svg>
  );
}
